/*
 * Copyright © 2026 Bruce Matin,  ALL RIGHTS RESERVED!
 */

import api from './api';
import { API_ENDPOINTS } from '../api/endpoints';

export const authService = {
  login: (credentials: any) => api.post(API_ENDPOINTS.AUTH.LOGIN, credentials),
  register: (userData: any) => api.post(API_ENDPOINTS.AUTH.REGISTER, userData),
  getProfile: () => api.get(API_ENDPOINTS.ME.PROFILE),
  updateProfile: (data: any) => api.put(API_ENDPOINTS.ME.PROFILE, data),
  getUserDetails: (id: string | number) => api.get(API_ENDPOINTS.USERS.DETAILS(id)),
  onboardStripe: () => api.post(API_ENDPOINTS.ME.STRIPE_ONBOARD),
};
